export const NotificationIcon: React.FC<any> = ({ className }) => {
  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{
        __html: `
        <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        >
        <g clip-path="url(#clip0_264_25)">
            <path
            d="M16.6665 6.66667C18.5048 6.66667 19.9998 5.17167 19.9998 3.33333C19.9998 1.495 18.5048 0 16.6665 0C14.8282 0 13.3332 1.495 13.3332 3.33333C13.3332 5.17167 14.8282 6.66667 16.6665 6.66667ZM16.6665 1.66667C17.5857 1.66667 18.3332 2.41417 18.3332 3.33333C18.3332 4.2525 17.5857 5 16.6665 5C15.7473 5 14.9998 4.2525 14.9998 3.33333C14.9998 2.41417 15.7473 1.66667 16.6665 1.66667ZM18.2232 8.58417C18.1173 8.13583 17.6607 7.86 17.2215 7.96333C16.7732 8.06917 16.4957 8.5175 16.6007 8.965L17.4815 12.7058C17.6348 13.2542 17.524 13.8292 17.1773 14.2833C16.8282 14.7392 16.2973 15 15.7207 15H4.279C3.72066 15 3.20066 14.7525 2.85233 14.3208C2.50483 13.89 2.37483 13.335 2.4865 12.8325L4.2315 6.35167C4.84816 3.59333 7.26649 1.6675 10.1115 1.6675C10.4698 1.6675 10.8273 1.69917 11.174 1.7625C11.6332 1.84417 12.0607 1.5425 12.1432 1.09083C12.2257 0.6375 11.924 0.204167 11.4715 0.121667C11.0265 0.0408333 10.569 0 10.1107 0C6.47983 0 3.39316 2.4625 2.61316 5.95333L0.868162 12.4333C0.636496 13.47 0.886496 14.5392 1.55483 15.3675C2.22066 16.1933 3.214 16.6675 4.279 16.6675H5.91733C6.30483 18.5667 7.98733 20.0008 9.99983 20.0008C12.0123 20.0008 13.6948 18.5667 14.0823 16.6675H15.7198C16.8198 16.6675 17.834 16.1675 18.5007 15.2958C19.1682 14.4225 19.3815 13.315 19.0948 12.2917L18.2232 8.58417ZM9.99983 18.3333C8.91483 18.3333 7.99816 17.6342 7.65316 16.6667H12.3457C12.0007 17.6342 11.0848 18.3333 9.99983 18.3333Z"
            fill="white"
            />
            <circle cx="16.5" cy="3.5" r="3.5" fill="#FE1F62" />
        </g>
        <defs>
            <clipPath id="clip0_264_25">
            <rect width="20" height="20" fill="white" />
            </clipPath>
        </defs>
        </svg>
    `,
      }}
    />
  );
};
